import { render, staticRenderFns } from "./TrangTaoNhomChucVu.vue?vue&type=template&id=3d2bf410&"
import script from "./TrangTaoNhomChucVu.vue?vue&type=script&lang=js&"
export * from "./TrangTaoNhomChucVu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports